export const NEWSLETTER_URL = "https://world.us21.list-manage.com/subscribe/post?u=52cabe9cfa943c69ee9796f8c&id=d5570d8dc0&f_id=0009e7e6f0"
